import { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { Container } from "base/src/components/Basic/Container/container"
import { View } from "base/src/components/Basic/View/view"
import { LoginByToken } from 'base/src/store/authentication/action/authenticationAction'
import AuthenticationContainer from '../../containers/authentication/authenticationContainer';
import { RootStateBase } from '../../store/baseStore';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GetAuthRoute, SistemaList } from 'domain/types/sistema/sistemaList'
import { Redirect, RouteParamters } from '../../utils/routeUtil';
import { connectUtil, PropsFromRedux } from "base/src/utils/reduxUtil";

const connector = connectUtil(
  (state: RootStateBase) => ({
    authState: state.AuthenticationReducer,
  }),
  { LoginByToken }
);

export interface AuthenticationProps extends PropsFromRedux<typeof connector> {
  sistemaID?: number;
}

function Authentication (props: AuthenticationProps) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [authInitiated, setAuthInitiated] = useState(false);
  const [redirected, setRedirected] = useState(false);

  const authenticationContainer = new AuthenticationContainer(props, searchParams);

  // Autenticação inicial
  useEffect(() => {
    if (!authInitiated) {
      setAuthInitiated(true);

      authenticationContainer.LoginByToken(() => {
        Redirect(GetAuthRoute());
      }, false);
    }
  }, [authInitiated]);

  // Redioreciona após autenticaçã
  useEffect(() => {
    if (props.authState.isAuthenticated && !redirected) {
      setRedirected(true);

      if (props.sistemaID == null) {
        toast("Sistema não foi definido");
        return;
      }

      if (props.sistemaID !== SistemaList.auth) {
        Redirect(GetAuthRoute(), [{
          key: RouteParamters.sistemaID,
          value: props.sistemaID,
        }]);
      } else {
        Redirect(GetAuthRoute());
      }
    }
  }, [props.authState.isAuthenticated, redirected, props.sistemaID]);

  useEffect(() => {
    if (props.authState && searchParams.has('token')) {
      searchParams.delete('token');
      setSearchParams(searchParams);
    }
  }, [props.authState, searchParams, setSearchParams]);

  return (
    <Container>
      <View style={{ width: "100%", height: "90%" }}>
        {t("Autenticando")}
      </View>
    </Container>
  );
}

export default connector(Authentication);